/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl';

import { jsx } from '@atlaskit/css';
import { RovoIcon } from '@atlaskit/logo/rovo/icon';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';

import messages from '../messages';
import type { AIBrand } from '../types';

export interface FooterAIBrandProps {
	/** The appearance of main footer. */
	appearance: 'small' | 'medium' | 'large';
	/** The brand to display */
	brand: AIBrand;
}

export function FooterAIBrand({ appearance }: FooterAIBrandProps): JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<Inline>
			{appearance !== 'small' && (
				<Box>
					<Text size="small" color="color.text.subtle">
						{formatMessage(messages.rovoCopyright)}
					</Text>
				</Box>
			)}
			<RovoIcon label={formatMessage(messages.rovoCopyright)} appearance="neutral" size="small" />
		</Inline>
	);
}
